var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.571 13.429h-17.143c-0.85715 0-1.4286-0.57142-1.4286-1.4286 0-0.85713 0.57143-1.4286 1.4286-1.4286h17.143c0.85716 0 1.4286 0.57142 1.4286 1.4286 0 0.85716-0.57142 1.4286-1.4286 1.4286z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 22c-0.85713 0-1.4286-0.57142-1.4286-1.4286v-17.143c0-0.85715 0.57144-1.4286 1.4286-1.4286 0.85716 0 1.4286 0.57143 1.4286 1.4286v17.143c0 0.85716-0.57142 1.4286-1.4286 1.4286z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.744c6b3640aa2657c8276cb202b703e6.svg";
export { ForwardRef as ReactComponent };